import { Google } from 'reaxl-analytics-handlers';

/**
 * @summary  GA360 impressions tag for Total Number of Listings
 */
export async function totalNumberListingsImpressions(metadata, option) {
    const {
        data = {},
    } = metadata;
    const { resultCount } = data;
    Google.sendImpressions(metadata, {
        eventElement: 'search-car',
        eventResult: `results::${resultCount}`,
        eventNonInteractive: false,
        eventData: {},
    }, option);
    return {};
}
